interface GraphQLErrorInfo {
  message: string;
  path?: readonly (string | number)[] | null;
  extensions?: Record<string, unknown> | null;
}

export default class SentryGraphQLError extends Error {
  readonly operation: string;
  graphqlErrors: readonly GraphQLErrorInfo[] = [];

  constructor(operation: string) {
    super(`${operation}: No data returned`);

    this.name = "SentryGraphQLError";
    this.operation = operation;

    Object.setPrototypeOf(this, SentryGraphQLError.prototype);
  }

  toSentryExtras(): Record<string, unknown> {
    return {
      "graphql.operation": this.operation,
      "graphql.errors": this.graphqlErrors.map((e) => ({
        message: e.message,
        path: e.path,
        extensions: e.extensions,
      })),
    };
  }
}
